import { WindDirection } from './WindDirection';
import { defaultWindDirectionSettings } from './defaultWindDirectionSettings';
export { WindDirection, defaultWindDirectionSettings };
